import styled from 'styled-components';

export const Section = styled.section`
  margin: 0 auto;
  max-width: 900px;
  width: 75%;
`;
